"use client"

import { PanelRightDashed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelRightDashedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelRightDashedIcon = component(Icon)({ as: PanelRightDashed })
